import { loader } from 'fetch-tree';
import { getContent, fetchContentForSection } from '../actions/content';
import { selectContent, selectContentForSection } from '../selectors/content';

export function contentResource(id, options) {
    return {
        id: `content-${id}`,
        load() {
            return options.dispatch(getContent(id));
        },
        find() {
            return selectContent(options.rootState, id) || {};
        },
    };
}

export const contentLoader = loader({
    id: id => `content-${id}`,
    action: getContent,
    selector: selectContent,
});

export function sectionContentResource(options, section) {
    return {
        id: `/content/section/${section.id}`,
        load() {
            return options.dispatch(fetchContentForSection(section));
        },
        find() {
            return selectContentForSection(options.rootState, section);
        },
    };
}

export const sectionContentLoader = loader({
    id: section => `/content/section/${section.id}`,
    action: fetchContentForSection,
    selector: selectContentForSection,
});



// WEBPACK FOOTER //
// ./src/resources/content.js